import { template as template_264fc4da75714811ba9f4cb6f898ec97 } from "@ember/template-compiler";
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import LinkInput from 'eflex/components/inputs/link-input';
import CheckboxInput from 'eflex/components/checkbox-input';
import { isPresent } from '@eflexsystems/ember-composable-helpers';
export default class ToolPropertiesUrlHyperlinkToggle extends Component {
    @tracked
    toggled = null;
    get isToggled() {
        return this.toggled === null ? isPresent(this.args.link) : this.toggled;
    }
    toggle = (toggle)=>{
        this.toggled = toggle;
        if (!toggle) {
            this.args.updateLink(null);
        }
    };
    static{
        template_264fc4da75714811ba9f4cb6f898ec97(`
    <div class="row flex-column gy-3">
      <div class="d-flex align-items-center">
        <CheckboxInput
          class="toggle-url-hyperlink {{if this.isToggled "toggled"}}"
          @disabled={{@disabled}}
          @checked={{this.isToggled}}
          @onChange={{this.toggle}}
        />
        <span class="fw-bold lh-1 {{if @disabled "opacity-25"}}">
          {{t "workInstructions.urlHyperlink"}}
        </span>
      </div>
      {{#if this.isToggled}}
        <div class="col-auto">
          <LinkInput
            @link={{@link}}
            @updateLink={{@updateLink}}
            @disabled={{@disabled}}
          />
        </div>
      {{/if}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
